import type { ThemeOptions } from '@mui/material/styles';

export const components: ThemeOptions['components'] = {
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        color: '#022b3a',
      },
    },
  },
  MuiContainer: {
    defaultProps: {
      maxWidth: false,
      disableGutters: true,
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        borderRadius: 8,
      },
      text: {
        color: '#022b3a',
        fontWeight: 700,
      },
      containedPrimary: {
        color: '#022b3a',
        fontWeight: 700,
        backgroundColor: '#ffd04b',
        '&:hover': {
          backgroundColor: '#ffdc73',
        },
      },
      containedSecondary: {
        color: '#ffffff',
        fontWeight: 700,
        backgroundColor: '#04ceff',
        '&:hover': {
          backgroundColor: '#04ceff',
        },
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        color: '#022b3a',
      },
    },
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        fontSize: '15px',
      },
    },
  },
  MuiTypography: {
    styleOverrides: {
      h4: {
        fontSize: '16px',
        fontWeight: 600,
      },
      h6: {
        fontSize: '16px',
      },
    },
  },
};
